<template>
  <v-form
    ref="form"
    v-model="valid"
    :lazy-validation="lazy"
    @keyup.native.enter="!$v.$invalid && onPressEnter($event)"
  >
    <v-card outlined>
      <v-card-title>
        <span v-if="isToAdd" class="headline">Crear Tipo Documento</span>
        <span v-else class="headline">Editar Tipo Documento</span>
      </v-card-title>

      <v-card-text class="text--primary">
        <v-row no-gutters>
          <v-col cols="12">
            <notification-container
              class="mr-5 ml-5"
              :showOnlyLocalNotifications="true"
            ></notification-container>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="documentType.clave"
              id="document_type_form__clave__text"
              autofocus
              :counter="10"
              :error-messages="getErrors('documentType.clave', 'La clave')"
              label="Clave"
              required
              @input="$v.documentType.clave.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="documentType.nombre"
              id="document_type_form__nombre__text"
              :counter="100"
              :error-messages="getErrors('documentType.nombre', 'El nombre')"
              label="Nombre"
              required
              @input="$v.documentType.nombre.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="text-right">
          <v-col cols="12">
            <v-btn
              color="secondary"
              @click.prevent="onCreate"
              id="document_type_form__guardar__button"
              :loading="loading"
              v-if="isToAdd"
              >Guardar</v-btn
            >
            <v-btn
              color="secondary"
              @click.prevent="onUpdate"
              id="document_type_form__actualizar__button"
              :loading="loading"
              v-else
              >Actualizar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { pushNotification, messageErrorResponse } from '@/store/helpers'
import { required, maxLength } from 'vuelidate/lib/validators'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { notSpecialCharsPunctuation } from '@/utils/VuelidateCustoms'
import {
  documentTypeStoreActions,
  documentTypeStoreData
} from '../store/documentTypeStoreHelpers'

export default {
  name: 'DocumentTypeForm',
  props: {
    value: Object
  },
  data: () => ({
    valid: true,
    loading: false,
    lazy: false,
    vuelidateHelper: null,
    documentType: {}
  }),
  computed: {
    ...documentTypeStoreData,
    isToAdd() {
      return this.value.idTipoDocumento === undefined
    }
  },
  created() {
    this.documentType = Object.assign({}, this.value)
    this.vuelidateHelper = new VuelidateHelper(this.$v)
  },
  validations: {
    documentType: {
      clave: {
        required,
        maxLength: maxLength(10),
        notSpecialCharsPunctuation
      },
      nombre: {
        required,
        maxLength: maxLength(100)
      }
    }
  },
  methods: {
    ...documentTypeStoreActions,
    onPressEnter() {
      if (this.isToAdd) {
        this.onCreate()
      } else {
        this.onUpdate()
      }
    },
    onCreate() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.loading = true

      this.createDocumentType(this.documentType)
        .then(result => {
          this.$emit('onCreate', result)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.loading = true

      this.updateDocumentType(this.documentType)
        .then(result => {
          this.$emit('onUpdate', result)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentTypeServiceError,
        'error',
        'left',
        false,
        true
      )
    }
  }
}
</script>
